import React, { useState, useRef, useContext, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Cruise_Description from "../../cruises/cruise-details/cruise_description/Cruise_Description";
import Itinerary2 from "./itinerary2/Itinerary2";
import Cruises_Policies from "../../cruises/cruise-details/cruise_policies/Cruise_Policies";
import WhatsCoveredTrip2 from "../whats_covered_in_trip2/Whats_Covered_In_Trip2";
import Common_Title from "../../common_component/common_title/Common_Title";
import Cruise_Booking from "../../cruises/cruise-details/cruise_booking/Cruise_Booking";
import Success_Modal from "../../contact-us/success_modal/Success_Modal";

import { useParams } from "react-router-dom";
import { Context } from "../../../utils/context";

function Location_Inner_Page() {
  const { id } = useParams();

  const [data, setData] = useState({});
  const [mainImage, setMainImage] = useState("");

  const { getData } = useContext(Context);

  const thumbRef = useRef();

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  console.log("Package Data:", data);

  const getDataAll = async () => {
    try {
      const response = await getData(`/master/package/${id}/`);

      const packageData = response?.data;

      setData(packageData);

      // Set first image as main image
      if (packageData?.images?.length > 0) {
        setMainImage(packageData.images[0].image);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [id]);

  const scrollUp = () => {
    thumbRef.current.scrollBy({
      top: -220,
      behavior: "smooth",
    });
  };

  const scrollDown = () => {
    thumbRef.current.scrollBy({
      top: 220,
      behavior: "smooth",
    });
  };

  // WhatsApp / Share Function
  const handleShare = async () => {
    try {
      const shareUrl = window.location.href;

      const shareText = `
${data?.title}

${data?.subtitle || ""}

📍 ${data?.location?.name}
🕒 ${data?.duration}
🎯 ${data?.activities_count} Activities
🏝️ ${data?.places_covered} Places Covered

${shareUrl}
      `;

      if (navigator.share) {
        await navigator.share({
          title: data?.title,
          text: shareText,
          url: shareUrl,
        });
      } else {
        navigator.clipboard.writeText(shareUrl);
        alert("Link copied to clipboard");
      }
    } catch (error) {
      console.log("Error sharing:", error);
    }
  };

  return (
    <>
      {/* SEO + WhatsApp Sharing Meta Tags */}
      <Helmet>
        <title>{data?.title || "Holiday Package"}</title>

        <meta
          name="description"
          content={
            data?.description ||
            "Explore amazing holiday packages with best prices."
          }
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />

        <meta property="og:title" content={data?.title || "Holiday Package"} />

        <meta
          property="og:description"
          content={
            data?.subtitle ||
            data?.description ||
            "Explore amazing holiday packages."
          }
        />

        <meta property="og:image" content={data?.holiday?.image || mainImage} />

        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content={data?.title || "Holiday Package"} />

        <meta
          name="twitter:description"
          content={
            data?.subtitle ||
            data?.description ||
            "Explore amazing holiday packages."
          }
        />

        <meta
          name="twitter:image"
          content={data?.holiday?.image || mainImage}
        />
      </Helmet>

      <section className="cruise_details_section location-inner-page">
        <div className="container">
          {/* Header */}
          <div className="cruise_header">
            <div className="title_with_badge">
              <Common_Title title={data?.title} />

              <span className="share_icon" onClick={handleShare}>
                <i className="fa-solid fa-share-nodes"></i>
              </span>
            </div>

            <p className="sub_title">
              ({data?.location?.name} | {data?.duration} |{" "}
              {data?.places_covered} Places | {data?.activities_count}{" "}
              Activities)
            </p>
          </div>

          {/* Gallery */}
          <div className="row gallery_row">
            {/* Left Side */}
            <div className="col-lg-8">
              <div className="main_cruise_img">
                <img
                  src={mainImage || data?.images?.[0]?.image}
                  alt={data?.title}
                />
              </div>

              <Cruise_Description data={data} />

              <Itinerary2 data={data} />
            </div>

            {/* Right Side */}
            <div className="col-lg-4">
              <div className="thumb_scroller">
                <button className="scroll_btn up" onClick={scrollUp}>
                  <i className="fa-solid fa-chevron-up"></i>
                </button>

                <div className="thumb_container" ref={thumbRef}>
                  {data?.images?.map((img, index) => (
                    <div
                      key={index}
                      className="thumb_img"
                      onClick={() => setMainImage(img?.image)}
                    >
                      <img src={img?.image} alt={`thumb-${index}`} />
                    </div>
                  ))}
                </div>

                <button className="scroll_btn down" onClick={scrollDown}>
                  <i className="fa-solid fa-chevron-down"></i>
                </button>
              </div>

              <Cruise_Booking
                data={data}
                onClick={() => {
                  setShowSuccessModal(true);

                  setTimeout(() => {
                    setShowSuccessModal(false);
                  }, 3000);
                }}
              />
            </div>
          </div>
        </div>

        {/* Included Sections */}
        <WhatsCoveredTrip2 data={data} />

        <Cruises_Policies data={data} />

        {/* Success Modal */}
        <Success_Modal
          show={showSuccessModal}
          handleClose={() => setShowSuccessModal(false)}
          successText="Form Submitted!"
        />
      </section>
    </>
  );
}

export default Location_Inner_Page;
